import React, {useEffect, useRef, useState} from "react";

const LocationSearchField = (props) => {

  const [address, setAddress] = useState('');
  const ref = useRef();
  const inputRef = useRef();

  const {
    selectLat,
    selectLng,
    selectAddress,
    selectIsAirport,
  } = props;

  useEffect(() => {
    if (inputRef.current) {
      const options = {
        componentRestrictions: { country: "nz" },
        fields: [
          "geometry",
          "types"
        ],
        strictBounds: false,
      };

      const autocomplete = new google.maps.places.Autocomplete(inputRef.current, options);

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        // console.log(place);
        if (selectLat) {
          selectLat(place.geometry.location.lat());
        }
        if (selectLng) {
          selectLng(place.geometry.location.lng());
        }

        if (inputRef.current) {
          selectAddress(inputRef.current.value);
          setAddress(inputRef.current.value);

          if (selectIsAirport) {
            // console.log(
            //   inputRef.current.value,
            //   inputRef.current.value.indexOf('Airport'),
            //   place.types.indexOf('airport') >= 0
            //   || inputRef.current.value.indexOf('Airport') >= 0
            // );
            selectIsAirport(
              place.types.indexOf('airport') >= 0
              || inputRef.current.value.indexOf('Airport') >= 0
            );
          }
        }

        // if (selectAddress) {
        //   selectAddress(place.formatted_address);
        // }
        // setAddress(place.formatted_address);

      });
    }
  }, [inputRef]);

  useEffect(() => {
    if (props.address) {
      setAddress(props.address);
    }
  }, [props.address]);

  return <div className="booking__suggestion__field"
    ref={ref}
    >
    <input
      type="text"
      aria-labelledby="address"
      placeholder=""
      required={true}
      ref={inputRef}
      value={address}
      onKeyDown={(e) => {
        if (e.key == 'Enter') {
          e.preventDefault();
        }
      }}
      onKeyUp={(e) => {
        if (e.key == 'Enter') {
          e.preventDefault();
        }
      }}
      onChange={(e) => {
        setAddress(e.target.value);
      }}
    />
  </div>

}

export default LocationSearchField;
